// @flow
import {DATE_RANGE_PICKER_SET_DATES_ACTION} from '../actions/dateRangePicker';
import type {Action} from '../actions/dateRangePicker';

export type State = {
    arrival: ?string,
    departure: ?string
};

const initialState = {
    arrival: null,
    departure: null
};

export default function reducer(
    state: State = initialState,
    action: Action
): State {
    if (action.type === DATE_RANGE_PICKER_SET_DATES_ACTION) {
        const {arrival, departure} = action.payload;
        return {
            ...state,
            arrival,
            departure
        };
    }
    return state;
}
